import styled from 'styled-components'

import { COLORS, TYPOGRAPHY } from './../../utils'

const Container = styled.div`
  z-index: 2;
  width: 100%;
  position: fixed;
  bottom: 0;
  box-shadow: 0px -5px 10px rgba(0, 0, 0, 0.28);
`

const FooterRights = styled.div`
  background-color: ${COLORS.lightGray};
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 4.125rem;
  padding: 0 7rem;
  span {
    color: ${COLORS.black};
    font-family: Arial;
    font-size: ${TYPOGRAPHY.bodySize16};
  }
  a {
    text-decoration: none;
    color: ${COLORS.black};
    font-family: Arial;
    font-size: 0.9rem;
    cursor: pointer;
  }
`

export { Container, FooterRights }
